import React from "react";
import { Avatar } from "@/components/ui";
import { Player } from "@/services/bedrock";

interface PlayerHeaderProps {
  player: Player;
}

export function PlayerHeader({ player }: PlayerHeaderProps) {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-3 min-w-0">
        <Avatar className="size-10 border-2 border-primary/10">
          <Avatar.Image src={player.photoUrl || undefined} />
          <Avatar.Fallback className="text-xs font-bold bg-primary/10 text-primary uppercase">
            {player.firstName?.[0]}
            {player.lastName?.[0]}
          </Avatar.Fallback>
        </Avatar>
        <div className="flex flex-col min-w-0 gap-1">
          <span className="text-sm font-bold truncate text-slate-900 leading-tight">
            {player.firstName} {player.lastName}
          </span>
          <span className="text-xs font-medium text-muted-foreground leading-none">{player.email}</span>
        </div>
      </div>
    </div>
  );
}
